import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { getThumb, getImg } from 'src/services/AssetApi';
import QuillEditor from 'src/components/quill-editor';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import ZoomImage from 'src/components/zoom-image';

export const DetailView = ({ item }) => {
  
  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={2}>
          <Grid container spacing={3} xs={12} md={6}>
            <Grid xs={6} md={6} sm={6}>
              <ReadOnlyTextField label="Ngày nhận xe" value={item.checkinSys} />
            </Grid>

            <Grid xs={6} md={6} sm={6}>
              <ReadOnlyTextField label="Ngày trả xe" value={item.checkoutSys} />
            </Grid>

            <Grid xs={12}>
              <ReadOnlyTextField label="Xe" value={item.car?.name} />
            </Grid>

            <Grid xs={6} md={6} sm={6}>
              <ReadOnlyTextField
                enumType="decimal"
                label="Km lúc nhận"
                value={item.checkinKm}
              />
            </Grid>

            <Grid xs={6} md={6} sm={6}>
              <ReadOnlyTextField
                enumType="decimal"
                label="Km lúc trả"
                value={item.checkoutKm}
              />
            </Grid>

            <Grid xs={12}>
              <QuillEditor
                value={item.note}
                isReadOnly={true}
              />
            </Grid>
          </Grid>
          {/* Right */}
          <Grid xs={12} md={6}>
            <Grid
              container
              spacing={2}
              sx={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                //height: '100%', // Ensure it takes the full height of the parent
              }}
            >
              {item.evidences?.map((img, index) => (
                <Grid item="true" key={index}>
                  <ZoomImage
                    thumbSrc={getThumb(img?.name)}
                    zoomSrc={getImg(img?.name)}
                    alt={img.id}
                    height="96"
                    frame="200px"
                    checked={!!img.location}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
};
